// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32KZm","content":"styles_content__jcoja"};